import { gql, useQuery } from "@apollo/client";
import React from "react";
import { useRouteMatch } from "react-router";
import { BreadCrumb, BreadCrumbProp } from "../../../../components/light/Breadcrumb";
import { Content } from "../../../../components/light/Content";
import { SectionBlock } from "../../../../components/light/SectionBlock";
import { Loading } from "../../../../components/Loading";
import moment from "moment";
import { StatusType } from "../../../../lib/StatusType";
import { IndexTable, LegacyCard } from "@shopify/polaris";
import { useTranslation } from "react-i18next";

const QUERY = gql`
  query merchantOrderByItem($id: Int!) {
    merchantOrderByItem(itemid: $id)
  }
`;

interface Props {
  called?: boolean;
}

export function ProductOrderItemScreen(props: Props) {
  const { t } = useTranslation();
  const { params }: any = useRouteMatch();
  const { data, loading } = useQuery(QUERY, {
    fetchPolicy: "no-cache",
    variables: {
      id: Number(params.id),
    },
  });
  const BreadCrumbItems: BreadCrumbProp[] = [
    {
      text: "Applications",
      to: "#",
    },
    {
      text: "Products",
      to: "#",
    },
    {
      text: "List",
      to: "/products/items",
    },
    {
      text: "Order Item",
      to: "/product/order/" + params.id,
    },
  ];

  if (data === undefined || loading) {
    return (
      <Content breadcrumb={props.called ? null : <BreadCrumb items={BreadCrumbItems} />}>
        <div className="row">
          <div className="col-md-6">
            <SectionBlock title="Order Item" transparent={true}>
              <Loading />
            </SectionBlock>
          </div>
        </div>
      </Content>
    );
  }

  return (
    <Content breadcrumb={props.called ? null : <BreadCrumb items={BreadCrumbItems} />}>
      <div className="row">
        <div className="col-md-6">
          {props.called && (
            <LegacyCard>
              <LegacyCard.Section>
                <b>{`${t('order')} ${t('item')} #${params.id}`}</b>
              </LegacyCard.Section>
              <LegacyCard.Section flush>
                <IndexTable
                  headings={[
                    { title: `${t('order')} ${t('status')}` },
                    { title: t("color"), alignment: "center" },
                    { title: t("size"), alignment: "center" },
                    { title: t("price"), alignment: "center" },
                    { title: t("order_date"), alignment: "end" },
                  ]}
                  itemCount={data.merchantOrderByItem.length || 0}
                  loading={loading}
                  selectable={false}
                >
                  {data &&
                    data.merchantOrderByItem.map((x: any, i: number) => {
                      return (
                        <IndexTable.Row position={i} id={i + ""} key={i}>
                          <IndexTable.Cell>
                            <small>
                              <strong>{t(StatusType[x.ostatus].toLowerCase())}</strong>
                            </small>
                          </IndexTable.Cell>
                          <IndexTable.Cell className="text-center">
                            <small>{x.color}</small>
                          </IndexTable.Cell>
                          <IndexTable.Cell className="text-center">
                            <small>{x.size}</small>
                          </IndexTable.Cell>
                          <IndexTable.Cell className="text-center text-success">${x.price}</IndexTable.Cell>
                          <IndexTable.Cell>
                            <div style={{ textAlign: "end" }}>
                              <small>{moment(new Date(x.ordered_date)).format("YYYY-MM-DD HH:mm:ss")}</small>
                            </div>
                          </IndexTable.Cell>
                        </IndexTable.Row>
                      );
                    })}
                </IndexTable>
              </LegacyCard.Section>
            </LegacyCard>
          )}
          {!props.called && (
            <SectionBlock title={"Order Item #" + params.id} transparent={true}>
              <table className="table table-stripped">
                <thead>
                  <tr>
                    <th>Order Status</th>
                    <th className="text-center">Color</th>
                    <th className="text-center">Size</th>
                    <th className="text-center">Price</th>
                    <th>Order Date</th>
                  </tr>
                </thead>
                <tbody>
                  {data.merchantOrderByItem.map((x: any, i: number) => {
                    return (
                      <tr key={i}>
                        <td>
                          <small>
                            <strong>{t(StatusType[x.ostatus].toLowerCase())}</strong>
                          </small>
                        </td>
                        <td className="text-center">
                          <small>{x.color}</small>
                        </td>
                        <td className="text-center">
                          <small>{x.size}</small>
                        </td>
                        <td className="text-center text-success">${x.price}</td>
                        <td>
                          <small>{moment(new Date(x.ordered_date)).format("YYYY-MM-DD HH:mm:ss")}</small>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </SectionBlock>
          )}
        </div>
      </div>
    </Content>
  );
}
